const breakpointDesktop = require("./utils/breakpoints.json").pd_desktop;
const pd_layout = require("corepd/layout");

pd_layout.elements.imagesTextContainer = ".ITC-container";
pd_layout.breakpoints.desktop = breakpointDesktop;
